import CreatePostControls from './scripts';

CreatePostControls.init();
